/*We apply the core concept of mobile first: all style rules will be set to be default for max-width:xs,
 * it means that different style behaviours must be specified for all other breakpoints ranges (if necessary), ranges will work as follows:
 * max-width: xs -> default
 * min-width: xs -> phone portrait up
 * min-width: sm -> tablet portrait
 * .... and so on
 * */
export const MEDIA_BREAKPOINT_KEYS = {
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
}
export const CUSTOM_BREAKPOINT_VALUES = {
  [MEDIA_BREAKPOINT_KEYS.xs]: 599,
  [MEDIA_BREAKPOINT_KEYS.sm]: 1024,
  [MEDIA_BREAKPOINT_KEYS.md]: 1200,
  [MEDIA_BREAKPOINT_KEYS.lg]: 1300,
  [MEDIA_BREAKPOINT_KEYS.xl]: 1680,
}

export const WINDOW_MEDIA_QUERIES = {
  [MEDIA_BREAKPOINT_KEYS.xs]: `@media (min-width: ${
    CUSTOM_BREAKPOINT_VALUES[MEDIA_BREAKPOINT_KEYS.xs]
  }px)`,
  [MEDIA_BREAKPOINT_KEYS.sm]: `@media (min-width: ${
    CUSTOM_BREAKPOINT_VALUES[MEDIA_BREAKPOINT_KEYS.sm]
  }px)`,
  [MEDIA_BREAKPOINT_KEYS.md]: `@media (min-width: ${
    CUSTOM_BREAKPOINT_VALUES[MEDIA_BREAKPOINT_KEYS.md]
  }px)`,
  [MEDIA_BREAKPOINT_KEYS.lg]: `@media (min-width: ${
    CUSTOM_BREAKPOINT_VALUES[MEDIA_BREAKPOINT_KEYS.lg]
  }px)`,
  [MEDIA_BREAKPOINT_KEYS.xl]: `@media (min-width: ${
    CUSTOM_BREAKPOINT_VALUES[MEDIA_BREAKPOINT_KEYS.xl]
  }px)`,
}

//returns an object containing the key-value style rule for the default value of the cssProperty as well as a key-value for each media query
//CAN BE USED FOR A SINGLE CSS PROPERTY for each element!
export const getMediaFor = (cssProperty, defaultValue, breakPointValues) => {
  const media = {
    [cssProperty]: defaultValue,
  }

  Object.keys(MEDIA_BREAKPOINT_KEYS)
    .filter(k => !!breakPointValues[k])
    .forEach(k => {
      return (media[`${WINDOW_MEDIA_QUERIES[k]}`] = {
        [cssProperty]: breakPointValues[k],
      })
    })
  return media
}

export const flexBox = {
  row: {
    display: "flex !important",
    flexDirection: "row",
  },
  column: {
    display: "flex !important",
    flexDirection: "column",
  },
}

//Use maxWidth to limit image size
export const responsiveImage = {
  width: "100%",
  height: "auto",
}

export const cardHighlight = {
  webkitBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.20)",
  boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.20)",
}

export const maxLines = lines => {
  return {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: lines,
    overflow: "hidden",
    textOverflow: "ellipsis",
  }
}

export const responsiveFontSize = (
  min,
  max,
  lowerBound = 320,
  upperBound = 1920
) =>
  `calc( ${min}px + (${max} - ${min}) * (100vw - ${lowerBound}px) / (${upperBound} - ${lowerBound}) )`
